export default __webpack_public_path__ + "static/media/id-front.e2b2f682.jpg";